import React from 'react';
import styles from './MensajeCargando.module.css';

/**
 * Componente para mostrar mensaje de cargando con spinner animado
 * Props:
 * - isCargando: boolean - si se está cargando
 * - entidad: string - tipo de entidad que se está cargando (ej: "partidos", "torneos", "clubes")
 * - estilo: string - clase CSS adicional
 * - mensaje: string - mensaje personalizado completo (sobrescribe entidad)
 */
const MensajeCargando = (props) => {
  const estiloAdicional = props.estilo;
  const isCargando = props.isCargando;
  const entidad = props.entidad || '';
  const mensajePersonalizado = props.mensaje;

  // Si hay mensaje personalizado, usarlo; sino construir con entidad
  let mensaje = mensajePersonalizado;
  if (!mensaje) {
    if (entidad) {
      mensaje = `Cargando ${entidad}...`;
    } else {
      mensaje = 'Cargando...';
    }
  }

  return (
    <React.Fragment>
      {isCargando && (
        <div className={`${styles.cargando} ${estiloAdicional || ''}`}>
          <span className={styles.spinner}>⟳</span> {mensaje}
        </div>
      )}
    </React.Fragment>
  );
};

export default MensajeCargando;
